(() => {
  const bindingKey = "__ofkHimariPdpV2Bound";
  if (window[bindingKey]) return;
  window[bindingKey] = true;
  const returnFocus = new WeakMap();
  const findSection = (element) => element?.closest("[data-ofk-himari-section]");

  const closeLightbox = (section) => {
    const lightbox = section?.querySelector("[data-ofk-himari-lightbox]");
    if (lightbox?.open) lightbox.close();
  };

  const openLightbox = (openButton, event) => {
    const gallery = openButton.closest("[data-ofk-himari-gallery]");
    const section = findSection(openButton);
    const main = gallery?.querySelector("[data-ofk-himari-main]");
    const lightbox = section?.querySelector("[data-ofk-himari-lightbox]");
    const lightboxImage = section?.querySelector("[data-ofk-himari-lightbox-image]");
    if (!main || !(lightbox instanceof HTMLDialogElement) || !lightboxImage) return false;

    event.preventDefault();
    if (lightbox.open) return true;
    returnFocus.set(lightbox, openButton);
    lightboxImage.src = main.currentSrc || main.src;
    lightboxImage.alt = main.alt;
    lightbox.hidden = false;
    lightbox.showModal();
    document.documentElement.classList.add("ofk-himari-lightbox-open");
    lightbox.querySelector("[data-ofk-himari-lightbox-close]")?.focus({ preventScroll: true });
    return true;
  };

  // Native dialogs contain focus and handle Escape, including after section replacement.
  document.addEventListener("close", (event) => {
    const lightbox = event.target;
    if (!(lightbox instanceof HTMLDialogElement) || !lightbox.matches("[data-ofk-himari-lightbox]")) return;
    lightbox.hidden = true;
    document.documentElement.classList.remove("ofk-himari-lightbox-open");
    const trigger = returnFocus.get(lightbox);
    returnFocus.delete(lightbox);
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  }, true);

  // This image dialog has one control. Keep keyboard traversal on its close button.
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Tab") return;
    const lightbox = document.querySelector("[data-ofk-himari-lightbox][open]");
    if (!(lightbox instanceof HTMLDialogElement) || !lightbox.matches(":modal")) return;
    const closeButton = lightbox.querySelector("[data-ofk-himari-lightbox-close]");
    if (!closeButton) return;
    event.preventDefault();
    closeButton.focus({ preventScroll: true });
  });

  document.addEventListener("shopify:section:unload", (event) => {
    event.target.querySelectorAll?.("[data-ofk-himari-lightbox][open]").forEach((lightbox) => lightbox.close());
  });

  const initMobileShopCta = () => {
    const mediaQuery = window.matchMedia("(max-width: 900px)");

    document.querySelectorAll("[data-ofk-himari-section]").forEach((section) => {
      const cta = section.querySelector("[data-ofk-himari-mobile-cta]");
      const buyPanel = section.querySelector("#himari-buy-panel");

      if (!cta || !buyPanel) return;

      const update = () => {
        const rect = buyPanel.getBoundingClientRect();
        const lightboxOpen = document.documentElement.classList.contains("ofk-himari-lightbox-open");
        const shouldShow = mediaQuery.matches && !lightboxOpen && rect.bottom < 0;

        section.querySelector("[data-himari-page]")?.classList.toggle("has-mobile-shop-cta", mediaQuery.matches);
        cta.classList.toggle("is-visible", shouldShow);
      };

      cta.addEventListener("click", (event) => {
        event.preventDefault();
        buyPanel.scrollIntoView({
          behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
          block: "start",
        });
      });

      window.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);

      if (typeof mediaQuery.addEventListener === "function") {
        mediaQuery.addEventListener("change", update);
      }

      update();
    });
  };

  document.addEventListener(
    "click",
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const thumb = target?.closest("[data-ofk-himari-thumb]");

      if (thumb) {
        const gallery = thumb.closest("[data-ofk-himari-gallery]");
        const main = gallery?.querySelector("[data-ofk-himari-main]");
        const thumbs = gallery?.querySelectorAll("[data-ofk-himari-thumb]");
        const source = thumb.dataset.src;

        if (!source || !main || !gallery || !thumbs) return;

        event.preventDefault();
        main.src = source;
        main.alt = thumb.dataset.alt || gallery.dataset.fallbackAlt || "Product image";

        thumbs.forEach((item) => {
          const active = item === thumb;
          item.classList.toggle("is-active", active);
          item.setAttribute("aria-pressed", String(active));
        });

        return;
      }

      const openButton = target?.closest("[data-ofk-himari-open]");

      if (openButton) {
        openLightbox(openButton, event);
        return;
      }

      const closeButton = target?.closest("[data-ofk-himari-lightbox-close]");

      if (closeButton) {
        event.preventDefault();
        closeLightbox(findSection(closeButton));
        return;
      }

      const lightbox = target?.closest("[data-ofk-himari-lightbox]");

      if (lightbox && target === lightbox) {
        closeLightbox(findSection(lightbox));
      }
    },
    true,
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMobileShopCta, { once: true });
  } else {
    initMobileShopCta();
  }
})();
